import { faRightFromBracket } from '@fortawesome/free-solid-svg-icons';
import { useEffect, useState } from 'react';
import { CustomTabItem } from '@types';
import {
  getBottomMenuOptions,
  getMenuOptions,
  menuType,
  prepareCustomTabs,
} from '@/components/Nav/utils';
import NavItemsList from '@/components/Nav/NavItemsList';
import { IUserContext, useUserContext } from '@/context/UserContext';
import useAccountData from '@/hooks/useAccountData';
import useCustomTabsPermissions from '@/hooks/useCustomTabsPermissions';
import InvestorsMenu from '@/components/Nav/InvestorsMenu';

interface NavItemsProps {
  isMobile?: boolean;
}
function NavItems({ isMobile = false }: NavItemsProps) {
  const [customTabInfo, setCustomTabInfo] = useState<CustomTabItem[] | null>(
    null
  );
  const { auth, impersonatingAccountId }: IUserContext = useUserContext();
  const { useCustomTabs } = useCustomTabsPermissions();
  const { getAccountData } = useAccountData();
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, no-nested-ternary
  const { data } = impersonatingAccountId
    ? getAccountData(impersonatingAccountId)
    : auth?.clients?.[0]?.id
    ? getAccountData(auth?.clients?.[0]?.id)
    : { data: null };
  const clientId = auth?.isClient
    ? auth?.clients?.[0]?.id
    : impersonatingAccountId || undefined;
  const { data: customTabs, isLoading } = useCustomTabs(
    auth?.id as number,
    clientId
  );
  useEffect(() => {
    if (customTabs) setCustomTabInfo(customTabs);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientId, isLoading]);
  // const customTabs = extractCustomTabsFromConfig(data?.config || []);

  const menuOptions = [
    ...getMenuOptions(
      menuType(impersonatingAccountId, auth),
      auth,
      prepareCustomTabs(customTabInfo),
      impersonatingAccountId,
      !!data
    ),
    ...getBottomMenuOptions(
      menuType(impersonatingAccountId, auth),
      auth,
      impersonatingAccountId
    ),
  ];
  const logOut = {
    icon: faRightFromBracket,
    label: 'Logout',
    url: '/logout',
    className: 'md:hidden',
  };
  return (
    <>
      <NavItemsList options={menuOptions} isMobile={isMobile} />
      <InvestorsMenu isMobile={isMobile} />
      <NavItemsList options={[logOut]} isMobile={isMobile} />
    </>
  );
}

export default NavItems;
